export const MIN_WIDTH = 40
export const COLLAPSE_WIDTH = 400
